<template>
 <b-row>
   <b-col>
     <table class="table table-sm">
       <tbody v-for="(item, index) in items" :key="index">
         <tr @click="toggleRow(item)" :key="item['@id']" class="tr-special">
           <td>
             <b-row>
               <b-col>
                 <span class="ml-2 mr-2" v-if="item['blockStatus'] === applicationStatuses.APPLICATION_BLOCK" style="color: #dc3545;"><i class="fa fa-lock fa-lg"></i></span>
                 <span class="ml-2 mr-2" v-if="item['blockStatus'] === applicationStatuses.APPLICATION_UNBLOCK" style="color: #28a745;"><i class="fa fa-unlock fa-lg"></i></span>
                 <span v-if="item['connectionStatus'] === applicationStatuses.CONNECTION_SUCCESS" v-b-tooltip.hover :title="$t('views.application.list.connectionSuccess')" style="color: #28a745" class="h6 mt-0 mb-0"><i class="fa fa-circle fa-lg mr-2"></i></span>
                 <span v-if="item['connectionStatus'] === applicationStatuses.CONNECTION_FAILURE" v-b-tooltip.hover :title="$t('views.application.list.connectionFailure')" style="color: #dc3545;" class="h6 mt-0 mb-0"><i class="fa fa-circle fa-lg mr-2"></i></span>
                 <span class="h6 mb-0">{{ item.subdomain + '.' + item.domain.domain }}</span>
               </b-col>
             </b-row>
           </td>
         </tr>
         <tr :key="index" @click="toggleRow(item)">
           <td colspan="4" class="expandable-row">
             <b-collapse :key="index" :id="index.toString()" v-model="item.visible">
               <b-row>
                 <b-col>
                   <application-show :data="item"></application-show>
                 </b-col>
               </b-row>
             </b-collapse>
           </td>
         </tr>
       </tbody>
     </table>
   </b-col>
 </b-row>
</template>

<script>
import ApplicationShow from '../../IAMBundle/application/Show'
import ApiService from '@/utils/ApiService'
import getIdFromLink from '@/utils/getIdFromLink'
import { applicationStatuses } from '@/utils/const/applicationStatuses'

export default {
  name: 'Applications',
  components: {
    ApplicationShow
  },
  data () {
    return {
      applicationStatuses,
      items: []
    }
  },
  props: {
    firm: Object
  },
  created () {
    this.items = []
    if (this.firm && this.firm.applications.length > 0) {
      this.firm.applications.forEach(entry => {
        this.getApplication(getIdFromLink(entry['@id']))
      })
    }
  },
  methods: {
    async getApplication (id) {
      const response = await new ApiService(`applications/${id}`, {}).getResults()
      response.visible = true
      this.items.push(response)
    },
    toggleRow (item) {
      item.visible = !item.visible
    }
  }
}
</script>

<style scoped>
  .tr-special:hover {
    background-image: linear-gradient(#f2f2f2, #ffffff);
  }
</style>
